import React from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { isLoggedIn, getEmployeeName, clearToken } from '../../api/contractUserClient';
import './My.css';

export default function MyManual() {
  const navigate = useNavigate();

  if (!isLoggedIn()) return <Navigate to="/my/login" replace />;

  const handleLogout = () => {
    if (window.confirm('로그아웃하시겠습니까?')) {
      clearToken();
      navigate('/my/login', { replace: true });
    }
  };

  return (
    <div className="my-page" style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <header className="my-page__header">
        <div className="container my-page__header-inner">
          <div>
            <img src="/logo.png" alt="주식회사 허브" className="my-page__logo-img" />
          </div>
          <div className="my-page__header-right">
            <button className="my-logout-btn" style={{ marginRight: '0.5rem' }} onClick={() => navigate('/my/contracts')}>
              ← 계약서 목록
            </button>
            <span className="text-muted">{getEmployeeName()}님</span>
            <button className="my-logout-btn" onClick={handleLogout}>로그아웃</button>
          </div>
        </div>
      </header>
      <iframe
        src="/manual/사용자_매뉴얼.html"
        title="사용자 매뉴얼"
        style={{ flex: 1, border: 'none', width: '100%' }}
      />
    </div>
  );
}
